import { getSessionSnapshot } from '../_lib/browserSession';

export function getToken() {
    return getSessionSnapshot().status === 'authenticated' ? 'cookie-session' : null;
}
